import React from 'react'
import { withRouter } from "react-router"

import Dialog from '@material-ui/core/Dialog'
import Grid from '@material-ui/core/Grid'

import EmptyStorage from 'components/common/EmptyStorage'

/*
  1501: 欲出窖的藏酒含有箱入藏酒 -> 返回托運車
  1502: 欲出窖的藏酒超過 24 瓶 -> 返回托運車
  1503: 尚有未付款的儲存費 -> 我要寄酒
*/

const CreateOrderResultDialog = props => {
	const onClick = () => {
		switch (props.errorCode) {
			case 1501:
			case 1502:
				props.history.push('/member/shippingcart')
				break;
			case 1503:
			default:
				props.history.push('/how-to-use', 2)
				break;
		}
	}

	return (
		<Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="md">
			<Grid container>
				<EmptyStorage type={`create-shipping-order-${props.errorCode}`} onClick={onClick} />
			</Grid>
		</Dialog>
	)
}

export default withRouter(CreateOrderResultDialog)
